module.exports = __webpack_public_path__ + "static/media/ocean_img.331e8bea.png";